import { createContext, useContext, useState, useCallback } from "react";
import ContactDialog from "./ContactDialog";

const ContactCtx = createContext({ open: () => {} });

export const useContact = () => useContext(ContactCtx);

export function ContactProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});

  const openDialog = useCallback((p = {}) => {
    setPrefill(p);
    setOpen(true);
  }, []);
  const closeDialog = useCallback(() => setOpen(false), []);

  return (
    <ContactCtx.Provider value={{ open: openDialog, close: closeDialog }}>
      {children}
      <ContactDialog open={open} onClose={closeDialog} prefill={prefill} />
    </ContactCtx.Provider>
  );
}
